import { useEffect, useMemo } from 'react'

/**
 * Object-URL for a locally selected file, revoked when the file is replaced and
 * on unmount. Returns null while there is no file or when disabled — pass
 * `enabled: false` for flows that never preview (spreadsheet imports).
 */
const useFilePreviewUrl = (file: File | null, enabled: boolean = true): string | null => {
  const url = useMemo(() => (file && enabled ? URL.createObjectURL(file) : null), [file, enabled])

  useEffect(() => {
    if (!url) return
    return () => URL.revokeObjectURL(url)
  }, [url])

  return url
}

export default useFilePreviewUrl
